export const text = {
	_title: 'Login',
	_email: 'email',
	_password: 'password',
	_submit: 'Login'
}

export const signup = {
	_title: 'Don\'t have an account',
	_body: 'Not a part of the mission for a cleaner feature? Let’s try it together!'
}

export default text;


// WEBPACK FOOTER //
// ./src/input-text/en/login_page.js